import React from "react";
import { Helmet } from "react-helmet";

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: "SYUKRA | Casual Shirts for Men",
  description: "Shop stylish casual shirts for men at SYUKRA, your go-to fashion destination.",
  keywords: "SYUKRA, casual shirts for men, men's casual wear, stylish shirts",
};


export default Meta;
